import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { MatDialog } from '@angular/material/dialog';
import { getProfileJobUpdate, addJobProfiles, addDirectory, addDirectoryProf, getBasicInfo, getBasicInfoProf, getDicectoryCategories, getDirCatsByPk, getPractice, getSupplier, getUeserPracDirectory, getUeserProfDirectory, getUeserSupDirectory, practiceData, professionalData, supplierData, updateBasicInfo, updateBasicInfoProf, getJobProfilesByProfessionalId, getJobEditById, updateTalentApproveStatusMutation, updateJobProfileMutation, deleteJobFromListMutation, getJobProfiledata, getAllJobsRoleList, getFilteredTalents, getJobProfileInfo, deleteJobHiringsByProfessionalIdMutation, getDirectoryCategory, deleteJobTalentEnquiryMutation, getTalentListMutation, getJobProfileList, getRelatedTalentListMutation, GET_TALENT_BY_ID, getTalentPreview } from '../queries/basicInfoTab.query';
import { ToastService } from 'src/app/core/toast.service';
import { LoginService } from 'src/app/core/services/login.service';
@Injectable({
  providedIn: 'root'
})
export class BasicInfoTabService {

  constructor(private apollo: Apollo, private _dialog: MatDialog, private toast: ToastService, private loginService: LoginService) { }
  getDirCategories() {

    return this.apollo.use("external").subscribe({
      query: getDicectoryCategories
    }).pipe(pluck('data', 'directory_categories'));

  }

  getDirCategory(professionType: string): Observable<{ id: string; name: string; }[]> {
    return this.apollo.use("external").query({
      query: getDirectoryCategory,
      variables: { name: professionType }
    }).pipe(pluck('data', 'directory_categories'));

  }

  async addBasicInfo(dirObj): Promise<any> {

    try {

      return await this.apollo.use("external").mutate({
        mutation: addDirectory,
        variables: { dirObj }
      }).pipe(pluck('data', 'insert_directories_one')).toPromise();

    } catch (err) {
      console.log(err);

    }

  }

  async addBasicInfoProfe(professinalObj): Promise<any> {

    try {
      await this.apollo.use("external").mutate({
        mutation: addDirectoryProf,
        variables: { professinalObj }
      }).pipe(pluck('data', 'insert_directories_one')).toPromise();

      this.toast.openSnackBar(
        'Your information added successfully'
      );

      return true;

    } catch (err) {
      console.log(err);

      this.toast.openSnackBar(
        'You Failed To add your information'
      );

      return false

    }

  }

  //Adding Job Profile
  async addJobProfile(jobProfile: any): Promise<any> {
    try {
      const res = await this.apollo.use("external").mutate({
        mutation: addJobProfiles,
        variables: { jobProfile }
      }).pipe(pluck('data', 'insert_job_profiles')).toPromise();
      return res; // Just return the actual result
    } catch (err) {
      console.log(err);
      throw err; // Throw error so that component can catch it
    }
  }

  userProfDirectory(id: string) {

    return this.apollo.use("external").subscribe({
      query: getUeserProfDirectory,
      variables: { id }
    }).pipe(pluck('data', 'directories'));

  }

  getProfileJobUpdate(id: string) {

    return this.apollo.use("external").subscribe({
      query: getProfileJobUpdate,
      variables: { id }
    }).pipe(pluck('data', 'directories'));

  }

  getDentalPractice(id: string) {

    return this.apollo.subscribe({
      query: getPractice,
      variables: { id }
    }).pipe(pluck('data', 'clients_by_pk'));

  }

  getDirCategoriesByPk(id: string) {

    return this.apollo.use("external").subscribe({
      query: getDirCatsByPk,
      variables: { id }
    }).pipe(pluck('data', 'directory_categories_by_pk'));

  }

  getDentalSupplier(id: string) {

    return this.apollo.use("external").subscribe({
      query: getSupplier,
      variables: { id }
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));

  }

  getJobProfilesByUser() {
    return this.apollo.use('external').query({
      query: getJobProfilesByProfessionalId,
    }).pipe(pluck('data', 'job_profiles'));
  }


  userSupDirectory(id: string) {

    return this.apollo.use("external").subscribe({
      query: getUeserSupDirectory,
      variables: { id }
    }).pipe(pluck('data', 'directories'));

  }

  userPracDirectory(id: string) {

    return this.apollo.use("external").subscribe({
      query: getUeserPracDirectory,
      variables: { id }
    }).pipe(pluck('data', 'directories'));

  }

  async updateBasicInfo(id, updateInfo): Promise<any> {

    try {

      await this.apollo.use("external").mutate({
        mutation: updateBasicInfo,
        variables: { id, updateInfo }
      }).pipe(pluck('data', 'update_directories')).toPromise();

      this.toast.openSnackBar(
        'Your information updated successfully'
      );
      return true;

    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('You Failed To updated your information');
      return false;

    }

  }

  async updateBasicInfoProfe(id, professinalUpdateObj): Promise<any> {

    try {

      await this.apollo.use("external").mutate({
        mutation: updateBasicInfoProf,
        variables: { id, professinalUpdateObj }
      }).pipe(pluck('data', 'update_directories')).toPromise();

      this.toast.openSnackBar(
        'Your information updated successfully'
      );
      return true;

    } catch (err) {
      console.log(err);
      this.toast.openSnackBar('You Failed To updated your information');
      return false;

    }

  }

  getBasicInfo(id: string) {

    return this.apollo.use("external").subscribe({
      query: getBasicInfo,
      variables: { id }
    }).pipe(pluck('data', 'directories_by_pk'));

  }

  getBasicInfoProf(id: string) {

    return this.apollo.use("external").subscribe({
      query: getBasicInfoProf,
      variables: { id }
    }).pipe(pluck('data', 'directories_by_pk'));

  }

  getSupplier(id: string) {

    return this.apollo.use("external").subscribe({
      query: supplierData,
      variables: { id },
      fetchPolicy: 'network-only',
    }).pipe(pluck('data', 'dental_suppliers_by_pk'));

  }

  getProfessional(id: string) {

    return this.apollo.use("external").subscribe({
      query: professionalData,
      variables: { id }
    }).pipe(pluck('data', 'dental_professionals_by_pk'));

  }

  getPractice(id: string) {

    return this.apollo.use("external").subscribe({
      query: practiceData,
      variables: { id }
    }).pipe(pluck('data', 'dental_practices_by_pk'));

  }


  getJobProfile() {
    return this.apollo.use("external").watchQuery({
      query: getJobProfiledata
    }).valueChanges.pipe(pluck('data', 'job_profiles'));
  }

  updateTalentStatus(jobId: string, status: string): Observable<any> {
    return this.apollo.mutate({
      mutation: updateTalentApproveStatusMutation,
      variables: {
        id: jobId,
        status: status
      }
    });
  }
  getJobById(jobId: string): Observable<any> {
    return this.apollo.query({
      query: getJobEditById,
      variables: { id: jobId },
      fetchPolicy: "network-only",
    }).pipe(pluck('data', 'job_profiles_by_pk'));
  }
  updateJobProfile(jobId: string, jobProfile: any): Promise<any> {
    return this.apollo
      .mutate({
        mutation: updateJobProfileMutation,
        variables: {
          id: jobId,
          postjobObj: jobProfile, // Object that contains the job profile data to update
        },
      })
      .toPromise()
      .then((result) => {
        // Handle success
        this.toast.openSnackBar('Job profile updated successfully');
        return result;
      })
      .catch((error) => {
        // Handle error
        console.error('Update error:', error);
        this.toast.openSnackBar('Failed to update job profile');
        throw error; // Rethrow the error so the caller can handle it as well
      });
  }
  deleteJobProfile(job_id: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteJobFromListMutation,
        variables: {
          id: job_id,
        },
      })
      .toPromise()
  }

  deleteJobHiringsByProfessionalId(professionalId: string): Promise<any> {
    return this.apollo.mutate({
      mutation: deleteJobHiringsByProfessionalIdMutation,
      variables: {
        dental_professional_id: professionalId
      }
    }).toPromise();
  }

  deleteJobTalentEnquiries(profileId: string): Promise<any> {
    return this.apollo.mutate({
      mutation: deleteJobTalentEnquiryMutation,
      variables: {
        id: profileId
      }
    }).toPromise();
  }

  getJobsRoleList(): Observable<any> {

    return this.apollo.subscribe({
      query: getAllJobsRoleList
    }).pipe(pluck('data', 'jobs_role_list'));
  }

  getFilteredTalentProfiles(filters: {
    professions?: string[],
    types?: string[],
    states?: string[],
    languages?: string[],
    avaidate?: string[],
    experience?: string;
    hiringPeriods?: any[],
    days?: string[],


  }): Observable<any[]> {
    const where: any = { _and: [] };
    if (filters.professions?.length) {
      where._and.push({ profession_type: { _in: filters.professions } });
    }
    if (filters.types?.length) {
      where._and.push({ work_type: { _has_keys_any: filters.types } });
    }
    if (filters.states?.length) {
      where._and.push({ state: { _in: filters.states } });
    }
    if (filters.languages?.length) {
      where._and.push({ languages_spoken: { _in: filters.languages } });
    }
    if (filters.avaidate?.length) {
      where._and.push({
        availabilityDate: { _has_keys_any: filters.avaidate }
      });
    }

    if (filters.days?.length) {
      where._and.push({
        availabilityDay: { _has_keys_any: filters.days }
      });
    }


    //  Experience filtering logic
    //  Direct experience match
    if (filters.experience) {
      where._and.push({ Year_of_experiance: { _eq: filters.experience } });
    }

    if (filters.hiringPeriods?.length) {

      if (filters.hiringPeriods.length === 1) {
        where._and.push(filters.hiringPeriods[0]);
      } else {
        where._and.push({ _or: filters.hiringPeriods });
      }
    }
    // If no filters are applied, match all
    if (where._and.length === 0) {
      delete where._and; // no filtering applied
    }
    return this.apollo.query<any>({
      query: getFilteredTalents,
      variables: { where }
    }).pipe(map(result => result.data.job_profiles));
  }

  getJobProfileData(id: any): Observable<any> {
    return this.apollo.use("external").subscribe({
      query: getJobProfileInfo,
      variables: {
        "id": id
      }
    }).pipe(pluck('data', 'job_profiles'));
  }



  // basic-info-tab.service.ts
  getJobProfileList(professionalId: string): Observable<any[]> {
    return this.apollo.use("external").watchQuery<{ job_profiles: any[] }>({
      query: getJobProfileList,
      variables: {
        professionalId: professionalId
      }
    }).valueChanges.pipe(
      pluck('data', 'job_profiles')
    );
  }

  // filter talent list

  getTalentList(
    limit: number,
    offset: number,
    filters: any = {},
    sort: string = 'asc'
  ): Observable<any[]> {


    // Build where object
    const where: any = { _and: [{ admin_status: { _eq: 'APPROVE' } }, { active_status: { _eq: 'ACTIVE' } }] };

    if (filters.searchText) {
      where._and.push({
        _or: [
          { full_name: { _ilike: `%${filters.searchText}%` } },
          { location: { _ilike: `%${filters.searchText}%` } },
          { city: { _ilike: `%${filters.searchText}%` } },
          { state: { _ilike: `%${filters.searchText}%` } },
        ],
      });
    }

    if (filters.profession_type) {
      where._and.push({ profession_type: { _eq: filters.profession_type } });
    }
    if (filters.excludeId) {
      where._and.push({ id: { _neq: filters.excludeId } });
    }



    if (filters.professions?.length) {
      where._and.push({ profession_type: { _in: filters.professions } });
    }
    if (filters.workTypes?.length) {
      where._and.push({ work_type: { _has_keys_any: filters.workTypes } });
    }

    if (filters.availabilityDates?.length) {
      where._and.push({ availabilityDate: { _has_keys_any: filters.availabilityDates } });
    }
    if (filters.availabilityDays?.length) {
      where._and.push({ availabilityDay: { _has_keys_any: filters.availabilityDays } });
    }
    if (filters.experience) {
      where._and.push({ Year_of_experiance: { _eq: filters.experience } });
    }


    // Sorting
    let order_by: any[] = [];
    if (sort === 'atoz') {
      order_by.push({ full_name: 'asc' });
    } else if (sort === 'ztoa') {
      order_by.push({ full_name: 'desc' });
    } else {
      order_by.push({ created_at: 'desc' });
    }

    return this.apollo.use("external").query({
      query: getTalentListMutation,
      variables: { limit, offset, where, order_by }
    }).pipe(pluck('data', 'job_profiles'));
  }


  // related talent list
  getRelatedTalentList(profession_type: string, limit: number, offset: number, excludeId?: string): Observable<any> {
    return this.apollo.use("external").watchQuery({
      query: getRelatedTalentListMutation,
      variables: { profession_type, limit, offset, excludeId },
      fetchPolicy: 'cache-and-network'
    }).valueChanges.pipe(pluck('data', 'job_profiles'));
  }

  /** Fetch a single directory record by its UUID */
  getTalentPreloginByid(id: string): Observable<any> {
    return this.apollo
      .query({
        query: GET_TALENT_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.job_profiles[0]));
  }

  getTalentPreview(id: string) {
    return this.apollo
      .use('external')
      .query({
        query: getTalentPreview,
        variables: { id }
      })
      .pipe(pluck('data', 'job_profiles'));
  }


}
